import SearchResultsPage from "src/pages/SearchResults";
export default SearchResultsPage;
